import { Module } from "vuex";
import { $api } from "@/services/api";
import { Option } from "@/models/form";
import { Address } from "@/models/application";
import { FeedbackRequestOption } from "@/models/feedback";
import { LOSType } from "@/models/opal";

const lookupsModule: Module<any, any> = {
  namespaced: true,
  state: {
    lookups: undefined as any,
    statesOptions: [] as Option[],
    addressUnitsOptions: [] as Option[],
    addressUnitTypes: [] as any[],
    addressUnitTypeOptions: [] as Option[],
    addressUnitTypePrefixes: [] as string[],
    countryOptions: [] as Option[],
    addressTypes: [] as any[],
    feedbackFormOptions: [] as FeedbackRequestOption[],
    consentTypes: [] as any[],
    states: [] as LOSType[],
    countries: [] as LOSType[],
    citizenshipStatusTypes: [] as LOSType[],
    citizenshipStatusOptions: [] as Option[],
  },
  getters: {
    statesOptions: (state: any): Array<Option> => {
      return state.statesOptions;
    },
    addressUnitsOptions: (state: any): Array<Option> => {
      return state.addressUnitsOptions;
    },
    countryOptions: (state: any): Array<Option> => {
      return state.countryOptions;
    },
    addressTypes: (state: any): Array<any> => {
      return state.addressTypes;
    },
    feedbackFormOptions: (state: any): Array<any> => {
      return state.feedbackFormOptions;
    },
  },
  mutations: {
    setLookups(state: any, lookups: any[]) {
      state.lookups = lookups;
    },
    setStateOptions(state: any, states: any[]) {
      state.statesOptions = states;
    },
    setAddressUnitsOptions(state: any, addressUnits: any[]) {
      state.addressUnitsOptions = addressUnits;
    },
    setCountryOptions(state: any, countries: any[]) {
      state.countryOptions = countries;
    },
    setAddressTypes(state: any, addressTypes: any[]) {
      state.addressTypes = addressTypes;
    },
    setAddress(state: any, address: Address) {
      state.address = address;
    },
    setFeedbackFormOptions(state: any, options: Address) {
      state.feedbackFormOptions = options;
    },
    setConsentTypes(state: any, consentTypes: any) {
      state.consentTypes = consentTypes;
    },
    setAddressUnitTypes(state: any, unitTypes: LOSType[]) {
      state.addressUnitTypes = unitTypes;
    },
    setAddressUnitTypeOptions(state: any, payload) {
      state.addressUnitTypeOptions = payload;
    },
    setAddressUnitTypePrefixes(state: any,  payload) {
			state.addressUnitTypePrefixes = payload;
    },
    setAddressStates(state: any, states: LOSType[]) {
      state.states = states;
    },
    setCitizenshipStatusTypes(state: any, options: LOSType[]) {
      state.citizenshipStatusTypes = options;
    },
    setCitizenshipStatusOptions(state: any, options: Option[]) {
      state.citizenshipStatusOptions = options;
    },
  },
  actions: {
    async getLookups({ commit }) {
      try {
        const lookups = await $api.lookups.getLookups();
        const addressUnitTypePrefixes = [] as string[];

        if (lookups) {
          commit("setLookups", lookups);
        }
        if (lookups.addressTypes) {
          commit("setAddressTypes", lookups.addressTypes);
        }
        if (lookups.states) {
          const statesOptions = lookups.states.map((c: any) => {
            return {
              label: c.name,
              value: c.id,
            };
          });
          commit("setAddressStates", lookups.states);
          commit("setStateOptions", statesOptions);
        }

        if (lookups.addressUnits) {
          lookups.addressUnits.forEach((au: any) => {
            addressUnitTypePrefixes.push(au?.abbreviation);
            addressUnitTypePrefixes.push(au?.name);
          });

          const addressUnitsOptions = lookups.addressUnits.map((c: any) => {
            return {
              label: c.name,
              value: c.id,
            };
          });

          commit("setAddressUnitTypes", lookups.addressUnits);
          commit("setAddressUnitsOptions", addressUnitsOptions);
          commit("setAddressUnitTypePrefixes", addressUnitTypePrefixes);
        }
        if (lookups.countries) {
          const countryOptions = lookups.countries.map((c: any) => {
            return {
              label: c.name,
              value: c.id,
            };
          });
          commit("setCountryOptions", countryOptions);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getFeedbackFormOptions({ state, commit }) {
      try {
        if (state.feedbackFormOptions?.length <= 0) {
          const options = await $api.feedback.getFeedbackFormOptions(3);
          commit("setFeedbackFormOptions", options);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getConsentTypes({ state, commit }) {
      try {
        if (state.consentTypes?.length <= 0) {
          const lookups = await $api.lookups.getConsentTypes();
          if (lookups?.length > 0) {
            commit("setConsentTypes", lookups);
          }
        }
      } catch (error) {
        console.log("Error: getConsentTypes()", error);
      }
    },
  },
};
export default lookupsModule;
